import { CloudQueueOutlined, Hive } from "@mui/icons-material"
import { Stack, Tooltip, Typography } from "@mui/material"
import { sysVersion } from "config/settings";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useState } from "react";
import { useSelector } from "react-redux";

const Footer = () => {
  const { bt } = useBizTypeTranslation();
  const wsIsConnected = useSelector((state) => state.sys?.wsIsConnected);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const openWebsite = () => {
    window.open("https://mybee.co.il", "_blank");
  }

  const fullScreen = () => {
    const elem = document.documentElement; // כל הדף
    if (!isFullScreen && elem.requestFullscreen) {
      elem.requestFullscreen();
      setIsFullScreen(true);
    }

    else if (isFullScreen && document.exitFullscreen) {
      document.exitFullscreen();
      setIsFullScreen(false);
    }
  }

  return (
    <Stack
      justifyItems='center'
      bgcolor="primary.main"
      py={0.5}
      px={1}
      direction='row'
      borderRadius="7px 7px 0 0"
      justifyContent='space-between'
    >
      <Typography variant="subtitle2" color='bg.main' onClick={fullScreen}>{`v-${sysVersion}`}</Typography>

      <Stack sx={{ cursor: "pointer" }} onClick={openWebsite} direction="row" spacing={0.5} alignItems="center">
        <Typography fontSize={14} sx={{ color: wsIsConnected ? "bg.main" : "error.text" }}>MyBee</Typography>
        <Tooltip title={wsIsConnected ? bt("WS_IS_CONNECTED") : bt("WS_IS_DISCONNECTED")}>
          <CloudQueueOutlined sx={{ color: wsIsConnected ? "bg.main" : "error.text" }} />
        </Tooltip>
      </Stack>

    </Stack>
  )
}
export default Footer